import classNames from "classnames";

import Image from "components/imageNew/image";
import { useMixpanelTracking } from "lib/hooks/useMixpanelTracking";
import { Breakfast, BreakfastPartnership } from "content-ui/breakfast/types";
import { formatDateEventCard } from "components/eventCard/utils";

import ApplyBlock from "../applyBlock/applyBlock";
import PartnershipBlock from "../partnershipBlock/partnershipBlock";

type DetailHeroProps = Breakfast & {
  isPrevious: boolean;
  hasRsvped: (id: string) => boolean;
  isRsvpReady: boolean;
};

const DetailHero = (props: DetailHeroProps) => {
  const {
    mainImage,
    title,
    city,
    moderators,
    dateTime,
    isPrevious,
    timezone,
    partnership,
  } = props;
  const { track } = useMixpanelTracking();
  const moderatorsList = moderators
    .map((moderator) => moderator.name)
    .join(", ");

  const handleClickOnPartner = async (partner: BreakfastPartnership) => {
    await track("Breakfast partner link click", {
      Component: "DetailHero",
      "Click link": partner.url,
      "Click text": partner.name,
    });
  };

  return (
    <div
      className={
        "flex flex-col gap-[14px] border-b-[#C8C8CC] md:border-b md:pb-[30px] lg:flex-row lg:gap-10 lg:pb-10"
      }
    >
      {!isPrevious && mainImage && (
        <div className={"flex w-full justify-center lg:w-auto"}>
          <div className={"margin-auto h-[240px] w-[240px] flex-none"}>
            <Image
              src={mainImage.url}
              alt={mainImage.alt || `${title} image`}
              width={mainImage.width}
              height={mainImage.height}
              blurDataURL={mainImage.blurUpThumb}
              className={"pointer-events-none h-full w-full object-cover"}
              sizes={"400px"}
            />
          </div>
        </div>
      )}
      <div className={"flex w-full flex-col justify-between"}>
        <div>
          <p
            className={
              "mb-2 font-bold text-[16px] leading-[130%] text-cerise lg:mb-1"
            }
          >
            Sifted Breakfasts
          </p>
          <h1
            className={
              "mb-[18px] font-recklessBold text-[18px] leading-[130%] md:text-[32px] lg:mb-3"
            }
          >
            {title}
          </h1>
          <div
            className={
              "flex flex-col justify-between gap-5 lg:flex-row lg:items-center"
            }
          >
            <div
              className={classNames("flex flex-col gap-2", {
                "mb-[30px] lg:mb-0": !isPrevious,
              })}
            >
              <p
                className={
                  "font-bold text-[14px] leading-[130%] text-mono-40 md:text-[16px]"
                }
              >
                {formatDateEventCard(new Date(dateTime), {
                  timezone: timezone,
                })}
              </p>
              <p className={"font-bold text-[14px] md:text-[16px]"}>
                In {city} with {moderatorsList}
              </p>
            </div>
            {isPrevious && partnership && (
              <div>
                <PartnershipBlock
                  {...partnership}
                  onClick={async () => handleClickOnPartner(partnership)}
                />
              </div>
            )}
          </div>
        </div>
        {!isPrevious && <ApplyBlock {...props} component={"DetailHero"} />}
      </div>
    </div>
  );
};

export default DetailHero;
